export default [
  {
    path: "/descuentos",
    component: () => import("@/views/tiposDescuento/Listar.vue"),
  },
  {
    path: "/descuentos/crear",
    component: () => import("@/views/tiposDescuento/Crear.vue"),
  },
  {
    path: "/descuentos/editar/:id",
    component: () => import("@/views/tiposDescuento/Editar.vue"),
  },
];
